export default __webpack_public_path__ + "static/media/android-button.2ed381fa.png";